export default {
  SET_SEARCH_FILTERS: 'SNOWPLOW_SET_SEARCH_FILTERS',
  VEHICLE_RESULTS_EVENT: 'SNOWPLOW_VEHICLE_RESULTS_UNSTRUCTURED_EVENT',
  SEARCH_INTERACTION: 'SNOWPLOW_SEARCH_INTERACTION_EVENT',
  STRUCTED_TRACKING_EVENT: 'SNOWPLOW_STRUCTURED_EVENT',
  PAYMENT_METHOD_TRACKING_EVENT: 'SNOWPLOW_ADD_PAYMENT_METHOD_ONLINE_SALE_CONTEXT',
  FINANCE_CALCULATOR_UNSTRUCTURED_TRACKING_EVENT: 'SNOWPLOW_VEHICLE_FINANCE_CALCULATOR_UNSTRUCTURED_EVENT',
  ADD_DELIVERY_TRACKING_EVENT: 'SNOWPLOW_ADD_DELIVERY_ONLINE_SALE_CONTEXT',
  ADD_EXTRA_TRACKING_EVENT: 'SNOWPLOW_ADD_EXTRA_ONLINE_SALE_CONTEXT',
  ADD_PART_EXCHANGE_TRACKING_EVENT: 'SNOWPLOW_ADD_PART_EXCHANGE_ONLINE_SALE_CONTEXT',
};
